import gsap from "gsap";

export default function cursorDelay (el) {
    el.addEventListener('mouseenter', mouseMover);

    const cursor = el.getElementsByClassName("cursor")[0];
    const cursorCircle = el.querySelector(".cursor-circle");

    function mouseMover() {
        cursor.style.display = 'block';
        let posS = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
        let posB = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
        let mouse = { x: posS.x, y: posS.y };
        const speed = 0.1;
        let fpms = 60 / 1000;

        function mouseHandler(e) {
            mouse.x = e.x;
            mouse.y = e.y;
        }

        window.addEventListener("mousemove", mouseHandler);

        const xSetCircle = gsap.quickSetter(cursorCircle, "x", "px");
        const ySetCircle = gsap.quickSetter(cursorCircle, "y", "px");

        gsap.ticker.add((time, deltaTime) => {
            let delta = deltaTime * fpms;
            let dt = 1.0 - Math.pow(1.0 - speed, delta);

            posB.x += (mouse.x - posB.x) * dt;
            posB.y += (mouse.y - posB.y) * dt;

            xSetCircle(posB.x);
            ySetCircle(posB.y);


            el.addEventListener('mouseleave', () => {
                cursor.style.display = 'none';
                window.removeEventListener('mousemove', mouseHandler)
            });
        });
    }
}

document.addEventListener('readystatechange', () => {

        const els = document.getElementsByClassName('cursor-component');
        Array.from(els).forEach(el => {

            cursorDelay(el);
        })
});
